module.exports = __webpack_public_path__ + "static/media/icon-tasks.381b183c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-tasks.svg
// module id = 1224
// module chunks = 19